import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["options", "value", "onChangeCountry", "onChange", "showClearButton", "searchPlaceholder", "onPaste", "className", "scrollList"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import mergeRefs from 'merge-refs';
import { forwardRef, useEffect, useMemo, useRef, useState } from 'react';
import { useIMask } from 'react-imask';
import { FieldText } from '@snack-uikit/fields';
import { useValueControl } from '@snack-uikit/utils';
import { PLACEHOLDER_CHAR } from './constants';
import styles from "./styles.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
export var FieldPhone = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var options = _ref.options,
    valueProp = _ref.value,
    onChangeCountry = _ref.onChangeCountry,
    onChangeProp = _ref.onChange,
    _ref$showClearButton = _ref.showClearButton,
    showClearButton = _ref$showClearButton === void 0 ? true : _ref$showClearButton,
    searchPlaceholder = _ref.searchPlaceholder,
    onPaste = _ref.onPaste,
    className = _ref.className,
    scrollList = _ref.scrollList,
    rest = _objectWithoutProperties(_ref, _excluded);
  var localRef = useRef(null);
  var isOnlyOneCountryAvailable = options.length === 1;
  var _useValueControl = useValueControl({
      defaultValue: options[0],
      onChange: onChangeCountry
    }),
    _useValueControl2 = _slicedToArray(_useValueControl, 2),
    country = _useValueControl2[0],
    setCountry = _useValueControl2[1];
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    dropdownSearch = _useState2[0],
    setDropDownSearch = _useState2[1];
  var items = useMemo(function () {
    if (dropdownSearch.length) {
      return options.filter(function (opt) {
        return [opt.content.option, opt.content.caption].some(function (val) {
          return String(val).toLowerCase().includes(dropdownSearch.toLowerCase());
        });
      });
    }
    return options;
  }, [options, dropdownSearch]);
  var maskOptions = useMemo(function () {
    return {
      mask: country === null || country === void 0 ? void 0 : country.mask,
      lazy: false,
      placeholderChar: PLACEHOLDER_CHAR,
      definitions: {
        X: /[0-9]/
      }
    };
  }, [country === null || country === void 0 ? void 0 : country.mask]);
  var _useIMask = useIMask(maskOptions, {
      onAccept: function onAccept(_, maskRef) {
        var unmasked = maskRef.unmaskedValue;
        var value = unmasked.length ? "".concat(country === null || country === void 0 ? void 0 : country.content.caption).concat(unmasked) : '';
        if (value !== valueProp) {
          onChangeProp === null || onChangeProp === void 0 ? void 0 : onChangeProp(value);
        }
      }
    }),
    iMaskRef = _useIMask.ref,
    iMaskValue = _useIMask.value,
    setValue = _useIMask.setValue,
    unmaskedValue = _useIMask.unmaskedValue;
  useEffect(function () {
    var _country$content$capt;
    var normalizedValue = valueProp === null || valueProp === void 0 ? void 0 : valueProp.replace((_country$content$capt = country === null || country === void 0 ? void 0 : country.content.caption) !== null && _country$content$capt !== void 0 ? _country$content$capt : '', '');
    if (normalizedValue !== undefined && normalizedValue !== unmaskedValue) {
      setValue(normalizedValue);
    }
    // need to trigger update only on valueProp change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueProp]);
  var handlePaste = function handlePaste(e) {
    var _e$clipboardData, _country$content$capt2;
    e.preventDefault();
    var text = ((_e$clipboardData = e.clipboardData) === null || _e$clipboardData === void 0 ? void 0 : _e$clipboardData.getData('text')) || '';
    var prefixNumber = ((_country$content$capt2 = country === null || country === void 0 ? void 0 : country.content.caption) !== null && _country$content$capt2 !== void 0 ? _country$content$capt2 : '').replace('+', '');
    var prefixNumberWithOptionalPlus = RegExp("^(\\+?".concat(prefixNumber, ")"));
    var valueWithoutPrefix = text.replace(prefixNumberWithOptionalPlus, '');

    // костыль, чтобы всегда срабатывала маска
    setValue("+".concat(valueWithoutPrefix));
    onPaste === null || onPaste === void 0 ? void 0 : onPaste(e);
  };
  var updateMaskView = function updateMaskView(value) {
    var _value$replaceAll;
    setValue((_value$replaceAll = value === null || value === void 0 ? void 0 : value.replaceAll(/\w/g, ' ')) !== null && _value$replaceAll !== void 0 ? _value$replaceAll : '');
  };
  var handleChangeSelection = function handleChangeSelection(selectedOption) {
    var _localRef$current;
    if (selectedOption && selectedOption !== (country === null || country === void 0 ? void 0 : country.content.option)) {
      var selectedCountry = options.find(function (opt) {
        return opt.id === selectedOption;
      });
      updateMaskView(selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.mask);
      setCountry(selectedCountry);
    }
    (_localRef$current = localRef.current) === null || _localRef$current === void 0 ? void 0 : _localRef$current.focus();
  };
  var handleChange = function handleChange(value) {
    // needed only to clear value by clicking on clear button
    if (unmaskedValue && !value) {
      var _localRef$current2;
      updateMaskView(country === null || country === void 0 ? void 0 : country.mask);
      (_localRef$current2 = localRef.current) === null || _localRef$current2 === void 0 ? void 0 : _localRef$current2.focus();
    }
  };
  var showClear = showClearButton && Boolean(unmaskedValue);
  return /*#__PURE__*/_jsx(FieldText, _objectSpread(_objectSpread({
    "data-test-id": "field-phone"
  }, rest), {}, {
    type: "tel",
    ref: mergeRefs(ref, localRef, iMaskRef),
    className: cn(className, styles.fieldPhone),
    "data-empty": !unmaskedValue || undefined,
    value: iMaskValue,
    onChange: handleChange,
    onPaste: handlePaste,
    showClearButton: showClear,
    prefix: country === null || country === void 0 ? void 0 : country.content.caption,
    button: isOnlyOneCountryAvailable ? undefined : {
      scroll: scrollList,
      variant: 'before',
      content: country === null || country === void 0 ? void 0 : country.beforeContent,
      items: items,
      selection: {
        onChange: handleChangeSelection,
        value: country === null || country === void 0 ? void 0 : country.id
      },
      search: {
        value: dropdownSearch,
        onChange: setDropDownSearch,
        placeholder: searchPlaceholder
      }
    }
  }));
});